export default "__VITE_ASSET__27ae6beb__"